import styles from "./Presentation.module.css";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";
import ViewActivityInfoIcon from "../ReleaseActivityPage/ViewActivityInfoIcon";
import React, {useState} from "react";
import {
    POLL_SHARE_MODE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import YuJaButton from "../../components/standardization/YuJaButton";
import EndPollModal from "../../components/modals/EndPollModal";
import {removePrefixNew} from "../../utils/helpers";
import {PollApiCalls} from "../../apis/PollApiCalls";
import ViewQuestionCard from "../ReleaseActivityPage/ViewQuestionCard";
import PollTimeLimitModal from "../../components/modals/PollTimeLimitModal";
import {ReactComponent as SQUARE_ICON} from "../ReleaseActivityPage/images/square.svg";
import { Accordion } from '@base-ui/react/accordion';


export default function ViewPresentPoll({pollData, localState, resetPollData, reactionCountData, responseCountData, userSettings}) {
    const { t } = useTranslation();
    const {poll, questions=[]} = pollData;
    const {pk, sk} = poll;
    let pollKey = removePrefixNew(pk);
    let pollCode = removePrefixNew(sk);

    const { shareAllQuestions, stopAllQuestions, updatePollDetails} = PollApiCalls();
    // const {createGradeColumn} = LTIApiCalls();

    const [endPollModalShow, setEndPollModalShow] = useState(false);
    const [openedQuestionNo, setOpenedQuestionNo] = useState(1);
    const [showPollTimeLimitModal, setShowPollTimeLimitModal] = useState(false);

    let isSharing =localState === "GET_READY_ALL" || localState === "SHARED_ALL";



    const handleStopAll = async () => {
        await stopAllQuestions(pollKey, pollCode);
        resetPollData();

    };



    const handleShareAll = async (pTimeLimit=undefined, getReadyAllTimeLimit=undefined) => {

        let requireUpdatePoll = pollData?.poll?.pollShareMode === POLL_SHARE_MODE.UNKNOWN
            || (pTimeLimit !== undefined && pTimeLimit !== pollData?.poll?.pollTimeLimit)
            || (getReadyAllTimeLimit !== undefined && getReadyAllTimeLimit !== pollData?.poll?.getReadyAllTimeLimit);

        if (requireUpdatePoll) {
            const pollDetails = {};
            pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_ALL;
            pollDetails.pollTimeLimit = pTimeLimit;
            pollDetails.manualEnd = !pTimeLimit;
            if (getReadyAllTimeLimit !== undefined) {
                pollDetails.getReadyAllTimeLimit =  getReadyAllTimeLimit;
            }

            await updatePollDetails(pollKey, pollCode, pollDetails, true);
        }
        let res = await shareAllQuestions(pollKey, pollCode);
        // createGradeColumn(pollKey, pollCode);
        resetPollData();
        // if (requireUpdatePoll) {
        //     resetPollData();
        // } else {
        //     setPollEnd(res.liveQuestionTime + (parseInt(getTimeOffset()) + pTimeLimit ? pTimeLimit : pollData.poll.pollTimeLimit) * 1000);
        //     setLocalState('GET_READY_ALL');
        //     resetPollData();
        // }
    };

    return (
        <div className={`${styles.rightPart} ${styles.column}`} style={{gap: 15}}>
            <EndPollModal
                show={endPollModalShow}
                setModalShow={setEndPollModalShow}
                localState={localState}
                poll={poll}
                handleStop={() => {}}
                handleStopAll={handleStopAll}
            />

            <PollTimeLimitModal
                show={showPollTimeLimitModal}
                setShow={setShowPollTimeLimitModal}
                pollData={pollData}
                handleShareAll={handleShareAll}
                handleOpen={() => {}}
                userSettings={userSettings}
            />

            <div className={styles.row}>
                <div className={styles.row} style={{gap: 7, flex: 1, minWidth: 120, marginRight: 10}}>
                    <span className={classes.pollTitleText}>{poll.pollTitle}</span>
                    <ViewActivityInfoIcon pollData={pollData}/>
                </div>


                {isSharing
                    ? <YuJaButton
                        tabIndex={0}
                        type={"delete"}
                        onClick={() => setEndPollModalShow(true)}
                        style={{width: 160, height: 40}}
                    >
                        <SQUARE_ICON style={{marginRight: 5}}/>

                        {t('common.finish')}
                    </YuJaButton>

                    : <div
                        tabIndex={0}
                        className={styles.releaseBtn}
                        onClick={() => setShowPollTimeLimitModal(true)}
                    >
                        {!!questions.filter(q => !!q.shareCount).length ? t('questionBuilder.releaseAgainButton') : t('questionBuilder.releasePollButton')}
                    </div>
                }
            </div>

            <Accordion.Root
                className={styles.column}
                style={{overflowY: "auto", flex: 1, maxHeight: "100%", gap: 15}}
                value={openedQuestionNo > 0 ? [openedQuestionNo] : []}
                onValueChange={(val) => {
                    if (!val.length) {
                        setOpenedQuestionNo(-1);
                    } else {
                        setOpenedQuestionNo(val[0]);
                    }
                }}
            >
                {questions.map((question, index) => {
                    return (
                        <ViewQuestionCard
                            key={index}
                            poll={poll}
                            currentQuestionNo={ -1}
                            localState={localState}
                            openedQuestionNo={openedQuestionNo}
                            question={question}
                            responseCountData={responseCountData}
                            reactionCountData={reactionCountData}
                        />
                    );
                })}
            </Accordion.Root>
        </div>
    );
}